// Reusable Gaussian-blur filter used for the cross-section "pulse" glow on
// the active rolling stand. Applied via filter="url(#visualizer-pulse-glow)".
// IMPORTANT: ONE filter shared by all elements that need a glow — Mario
// flagged that `<feGaussianBlur>` is the most expensive SVG primitive, so
// keep instances minimal.

export const PULSE_FILTER_ID = "visualizer-pulse-glow";

export const PulseFilter = () => (
	<filter id={PULSE_FILTER_ID} x="-30%" y="-30%" width="160%" height="160%">
		<feGaussianBlur stdDeviation="2.5" result="blur" />
		<feMerge>
			<feMergeNode in="blur" />
			<feMergeNode in="SourceGraphic" />
		</feMerge>
	</filter>
);
